const getHTML = async (url: string) => {
  const fetchURL = `${window.location.origin}/${url}`;
  const request = await fetch(fetchURL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const text = await request.text();
  const parser = new DOMParser();
  const html = parser.parseFromString(text, "text/html");

  return html;
};

export default getHTML;
